import React from "react";
import { useLocation, Link } from "react-router-dom";

const CONTENT = {
  cgv: {
    title: "Conditions Générales de Vente",
    updated: "Dernière mise à jour : juillet 2026",
    sections: [
      ["1. Objet", "Les présentes conditions générales régissent l'utilisation de la plateforme YADIMMO et les services d'accompagnement à l'investissement immobilier au Maroc (recherche de biens, financement, logistique et conciergerie)."],
      ["2. Services", "YADIMMO propose la mise en relation avec des programmes immobiliers neufs, des biens avec rénovation incluse, des entrepôts logistiques et des locaux d'entreprise, ainsi qu'un accompagnement juridique, bancaire et logistique clé en main."],
      ["3. Prix", "Les prix des biens sont indiqués en dirham marocain (MAD) et convertis à titre indicatif en euro (€) selon le taux de change en vigueur. Les mensualités affichées sont des estimations non contractuelles."],
      ["4. Financement", "Grâce au partenariat avec le Crédit Agricole du Maroc, YADIMMO facilite l'accès au crédit. L'octroi d'un prêt reste soumis à l'accord de l'établissement bancaire après étude du dossier."],
      ["5. Responsabilité", "YADIMMO agit en qualité d'intermédiaire et met tout en œuvre pour la fiabilité des informations, sans garantie d'exhaustivité. Les transactions sont sécurisées par nos partenaires notaires et avocats."],
      ["6. Rétractation", "Conformément à la réglementation applicable, le client dispose des droits légaux relatifs à toute réservation. Les modalités précises sont communiquées lors de la signature."],
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    updated: "Dernière mise à jour : juillet 2026",
    sections: [
      ["1. Données collectées", "Nous collectons les informations que vous nous transmettez (nom, email, téléphone, documents de dossier) ainsi que les données de navigation nécessaires au bon fonctionnement du service."],
      ["2. Finalités", "Vos données servent à traiter vos demandes, constituer votre dossier de financement, planifier vos rendez-vous, gérer vos alertes et améliorer nos services."],
      ["3. Assistant José", "Les échanges avec notre assistant virtuel peuvent être conservés afin d'assurer un suivi de qualité par notre service client."],
      ["4. Partage", "Vos données ne sont partagées qu'avec nos partenaires directement impliqués dans votre projet (banque, notaire, avocat) et ne sont jamais revendues."],
      ["5. Conservation & sécurité", "Les documents sont stockés de manière sécurisée. Vous pouvez demander la suppression de vos données à tout moment."],
      ["6. Vos droits", "Vous disposez d'un droit d'accès, de rectification et de suppression de vos données en nous contactant à contact@yadimmo.com."],
    ],
  },
  "mentions-legales": {
    title: "Mentions légales",
    updated: "Dernière mise à jour : juillet 2026",
    sections: [
      ["Éditeur", "YADIMMO — Plateforme d'investissement immobilier au Maroc. Bureaux à Aix-en-Provence (France) et Marrakech (Maroc)."],
      ["Contact", "Email : contact@yadimmo.com — Téléphone : +212 5 22 00 00 00"],
      ["Hébergement", "Le site est hébergé sur une infrastructure cloud sécurisée."],
      ["Propriété intellectuelle", "L'ensemble des contenus (textes, visuels, marque YADIMMO) est protégé. Le logo du Crédit Agricole du Maroc est utilisé dans le cadre d'un partenariat."],
      ["Cookies", "Le site utilise des cookies strictement nécessaires à son fonctionnement et à la mesure d'audience."],
    ],
  },
};

const LegalPage = () => {
  const { pathname } = useLocation();
  const slug = pathname.replace("/", "");
  const data = CONTENT[slug] || CONTENT.cgv;

  return (
    <div className="relative z-10 pt-[72px] min-h-screen bg-background">
      <div className="bg-navy text-white py-16">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <span className="overline text-gold">Informations légales</span>
          <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight mt-3">{data.title}</h1>
          <p className="text-white/50 text-sm mt-3">{data.updated}</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <div className="space-y-9">
          {data.sections.map(([h, body]) => (
            <div key={h}>
              <h2 className="font-display text-xl text-navy mb-2">{h}</h2>
              <p className="text-muted-foreground leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/cgv" className="text-navy hover:text-gold font-medium">CGV</Link>
          <Link to="/confidentialite" className="text-navy hover:text-gold font-medium">Confidentialité</Link>
          <Link to="/mentions-legales" className="text-navy hover:text-gold font-medium">Mentions légales</Link>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
